module.exports = __webpack_public_path__ + "img/history_timeline_10.97306c87.png";